/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import leftArrow from '../../assets/images/header/leftarrows.svg';
import rightArrow from '../../assets/images/header/rightArrows.svg';
import bold from '../../assets/images/header/bold-svg.svg';
import italic from '../../assets/images/header/italic-svg.svg';
import underline from '../../assets/images/header/underline-svg.svg';
import orderList from '../../assets/images/header/bullet-list-svg.svg';
import numberList from '../../assets/images/header/numbered_list.png';
import ArrowDown from '../../assets/images/arrow_down.svg';
import link from '../../assets/images/header/link-svg.svg';
import { useSelector } from 'react-redux';
import search from '../../assets/images/model/search.svg';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import easyRead from '../../assets/images/model/Easy_read_mode.png';
import alignLeft from '../../assets/images/header/align-left.svg';
import alignCenter from '../../assets/images/header/align-center.svg';
import alignRight from '../../assets/images/header/align-right.svg';
import alignJustify from '../../assets/images/header/align-justify.svg';
import help from '../../assets/images/model/help.png';
import dashboard from '../../assets/images/model/dashboard.png';
import bell from '../../assets/images/model/bell.png';
import menu from '../../assets/images/model/menu.png';
import { useDispatch } from 'react-redux';
import { setBooks } from '../../Store/entities/books';
import { professorBooks } from '../../Store/api/books';
import storage from '../../services/storage';
import { SelectOption } from '../../Pages/Book/models/SelectOption';
import { CustomDropDown } from '../../shared/CustomDropDown';
import { ModalPortal } from '../ModalPortal';
import { CustomModal } from '../../shared/CustomModal';
import { ProfileDropdown } from '../../shared/ProfileDropdown';

const alignOptions = [
  { value: 'left', imageUrl: alignLeft },
  { value: 'center', imageUrl: alignCenter },
  { value: 'right', imageUrl: alignRight },
  { value: 'justify', imageUrl: alignJustify },
];

const fontFamilies = [
  { value: 'Arial, sans-serif', label: 'Arial' },
  { value: 'Inter, sans-serif', label: 'Inter' },
  { value: 'Lora', label: 'Lora' },
  { value: 'Times New Roman', label: 'Times New Roman' },
];

const fontSizes = [
  { value: 0, label: 'Fit', borderBottom: true },
  { value: 1, label: '50%' },
  { value: 2, label: '80%' },
  { value: 3, label: '100%' },
  { value: 4, label: '110%' },
  { value: 5, label: '120%' },
  { value: 6, label: '130%' },
  { value: 7, label: '140%' },
  { value: 8, label: '150%' },
];

const EditorToolbarFun = ({
  undo,
  editableElementRef,
  redo,
  changeFontSize,
  changeFontFamily,
  updateFormatting,
  createLink,
  toggleBullets,
  toggleOrders,
  editorState,
  bookId,
  style = {},
  handleTextAlignChange,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [params] = useSearchParams();
  const Storeuser = storage.get('user');
  const queryParam = params.get('openModel');
  const status = Storeuser?.status === 'waiting';
  const [showModal, setShowModal] = useState(status);
  const [userStatus, setUserStatus] = useState(false);
  const [dropdownToggle, setDropdownToggle] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const books = useSelector((state) => state.entities.books.all);
  const [selectedBook, setSelectedBook] = useState(null);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [lastBookId, setLastBookId] = useState(null);
  const [selectOption, setSelectOption] = useState(queryParam || false);
  const [isFontDropdownOpen, setIsFontDropdownOpen] = useState(false);
  const [isAlignDropdownOpen, setIsAlignDropdownOpen] = useState(false);
  const wrapperRef = useRef();
  const selectRef = useRef(null);

  const toggleSearch = () => {
    setIsSearchActive((old) => !old);
  };
  const handleDropDowntoggle = () => setDropdownToggle((prev) => !prev);

  const toggleActive = () => {
    setIsActive((prev) => !prev);
  };

  useEffect(() => {
    const storedBookId = localStorage.getItem('lastBookId');
    if (storedBookId) {
      setLastBookId(storedBookId);
      const book = books.find((b) => b._id === storedBookId);
      if (book) {
        setSelectedBook(book);
      }
    }
  }, [books]);

  // Store the current bookId to local storage if it changes
  useEffect(() => {
    if (bookId) {
      // localStorage.setItem('lastBookId', bookId);
      const book = books.find((b) => b._id === bookId);
      if (book) {
        setSelectedBook(book);
      }
    }
  }, [bookId, books]);

  const handleBookSelect = (book) => {
    setSelectedBook(book);
    navigate(`/create/${book._id}`);
    localStorage.setItem('lastBookId', book._id);
  };

  useEffect(() => {
    dispatch(
      professorBooks({
        onSuccess: (res) => {
          dispatch(setBooks(res.data.data));
        },
        onError: (error) => {},
      })
    );
  }, [dispatch]);

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setIsActive(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const onHide = useCallback(() => {
    setUserStatus(false);
    setShowModal(false);
  }, []);

  return (
    <>
      <ModalPortal>
        <CustomModal
          isLink
          onHide={onHide}
          onAction={onHide}
          showModal={userStatus}
          actionBtnText='Done'
          title='not yet verified'
          cancelBtnText='Go to greyledteach'
          supportContent='support@greyled.com.'
          otherContent='You can still use the Greyled system but activities and their answers will be limited to protect the work of other professors.'
          content='The Greyled team is still working on verifying your professor status. If you have been waiting longer than 24 hours for professor validation, please contact '
        />
      </ModalPortal>
      <div
        className={`top_header_edit_option_create ${isSearchActive ? 'active' : ''}`}
        style={{
          ...style,
          gap: '25px',
          // justifyContent: "space-between",
          width: '100%',
          maxWidth: 'none',
          marginBottom: '5px',
          marginTop: '10px !important',
        }}
      >
        <div
          style={{
            width: '58%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div className='edit_list_create' style={{ width: '100%' }}>
            <ul className='create_ul' style={{ justifyContent: 'space-between', gap: '0px' }}>
              <li className='me-0'>
                <button
                  disabled={
                    editorState.currentStateIndex <= 0 || editorState?.currentState?.length === 0
                  }
                  onClick={undo}
                  className={`tool-button ${
                    editorState.currentStateIndex <= 0 ? 'tool-button-unactive' : ''
                  }`}
                  style={{}}
                >
                  <img src={leftArrow} alt='left-arrow' />
                </button>
              </li>
              <li className='m-0'>
                <button
                  disabled={
                    editorState?.currentStateIndex >= editorState?.currentState?.length - 1
                  }
                  onClick={redo}
                  className={`tool-button`}
                >
                  <img src={rightArrow} alt='right-arrow' />
                </button>
              </li>
              <li className='m-0'>
                <div className='d-flex align-items-center'>
                  {/* <CustomDropDown options={fontSizes} handleClick={changeFontSize} selectedValue={editorState.formatting.fontSize} style={{ padding: '6px 0px', textAlign: 'center' }} /> */}
                  <CustomDropDown
                    isOpen={isFontDropdownOpen}
                    setIsOpen={setIsFontDropdownOpen}
                    options={fontFamilies}
                    style={{ padding: '10px' }}
                    handleClick={changeFontFamily}
                    selectedValue={editorState.fontFamily}
                    className='select-font-family-container'
                  />
                  <CustomDropDown
                    isOpen={isAlignDropdownOpen}
                    setIsOpen={setIsAlignDropdownOpen}
                    optionsAsImages
                    options={alignOptions}
                    show={dropdownToggle}
                    onToggle={handleDropDowntoggle}
                    handleClick={handleTextAlignChange}
                    selectedValue={editorState.formatting.align}
                    dropdownButtonClassName='select-align-options-button'
                    menuStyle={{ minWidth: '10rem' }}
                  />
                </div>
              </li>
              <li className='m-0'>
                <button
                  disabled={!Object.keys(editableElementRef.current).length}
                  onClick={() => updateFormatting('bold')}
                  className={`tool-button ${
                    editorState.formatting.bold && Object.keys(editableElementRef.current).length
                      ? 'active editor_text_options'
                      : ''
                  }`}
                >
                  <img src={bold} alt='bold' />
                </button>
              </li>
              <li className='m-0'>
                <button
                  disabled={!Object.keys(editableElementRef.current).length}
                  onClick={() => updateFormatting('italic')}
                  className={`tool-button ${
                    editorState.formatting.italic && Object.keys(editableElementRef.current).length
                      ? 'active editor_text_options'
                      : ''
                  }`}
                >
                  <img src={italic} alt='italic' />
                </button>
              </li>
              <li className='m-0'>
                <button
                  disabled={!Object.keys(editableElementRef.current).length}
                  onClick={() => updateFormatting('underline')}
                  className={`tool-button ${
                    editorState.formatting.underline &&
                    Object.keys(editableElementRef.current).length
                      ? 'active editor_text_options'
                      : ''
                  }`}
                >
                  <img src={underline} alt='underline' />
                </button>
              </li>
              <li className='m-0'>
                <button
                  disabled={!Object.keys(editableElementRef.current).length}
                  onClick={toggleOrders}
                  className={`tool-button ${
                    editorState.formatting.orders && Object.keys(editableElementRef.current).length
                      ? 'active'
                      : ''
                  }`}
                >
                  <img src={numberList} alt='toggleOrders' />
                </button>
              </li>
              <li className='m-0'>
                <button
                  disabled={!Object.keys(editableElementRef.current).length}
                  onClick={toggleBullets}
                  className={`tool-button ${
                    editorState.formatting.bullets &&
                    Object.keys(editableElementRef.current).length
                      ? 'active editor_text_options'
                      : ''
                  }`}
                >
                  <img src={orderList} alt='toggleBullets' />
                </button>
              </li>

              <li className='m-0'>
                <button
                  disabled={!Object.keys(editableElementRef.current).length}
                  onClick={createLink}
                  className={`tool-button ${
                    editorState.formatting.link && Object.keys(editableElementRef.current).length
                      ? 'active'
                      : ''
                  }`}
                >
                  <img src={link} alt='toggleOrders' />
                </button>
              </li>
            </ul>
          </div>
          <div className='search_box_create' style={{ paddingLeft: '24px' }}>
            <div className={`search_inner ${isSearchActive ? 'active' : ''}`}>
              <div className='input_wrap_search_create'>
                <input
                  type='search'
                  className='form-control search_input_create'
                  placeholder='Search in book'
                  style={{ width: '55%', marginLeft: '10px' }}
                />
              </div>
              <button type='button' className='search_btn_create' onClick={toggleSearch}>
                <img src={search} alt='search' />
              </button>
            </div>
          </div>
        </div>
        <div style={{ width: '42%' }}>
          <div className='rigt_list_top'>
            <div className='edit_list_create '>
              <ul className='create_ul' style={{ justifyContent: 'space-between' }}>
                <div
                  className='header_right_side_container'
                  style={{
                    width: '16%',
                    justifyContent: 'space-around',
                  }}
                >
                  <li className='m-0'>
                    <img src={easyRead} alt='Easy_read_mode' />
                  </li>
                  <li className='ms-0'>
                    <a href='https://docs.greyled.com' target='_blank' rel='noreferrer'>
                      <img src={help} alt='help' />
                    </a>
                  </li>
                </div>
                <li className='create_selector m-0' style={{ width: '50%' }}>
                  <div className='select_option w-100' ref={wrapperRef}>
                    <div
                      ref={selectRef}
                      onClick={toggleActive}
                      className={`w-100 select_wrap_create custom_option_create custom_select_create  ${
                        isActive ? 'active' : ''
                      }`}
                      style={{ background: 'none', backgroundImage: 'none' }}
                    >
                      <div style={{ display: 'flex' }}>
                        <p className='main_text_option mb-0 cursor'>
                          {selectedBook
                            ? `${selectedBook.title.slice(0, 34)}${
                                selectedBook.title.length > 34 ? '...' : ''
                              }`
                            : 'Book Select'}
                        </p>

                        {/* Arrow Image */}
                        <img
                          src={ArrowDown}
                          alt='Dropdown Arrow'
                          className={`arrow-icon-font ${
                            isActive ? 'rotate-up-font' : 'rotate-down-font'
                          }`}
                        />
                      </div>

                      <div className='select_option_inner_cr' style={{ width: '100.7%' }}>
                        <p>Choose which book to edit</p>
                        <div className='list-class'>
                          <ul className='option_list_create '>
                            {books.map((book, index) => (
                              <li
                                key={index}
                                style={{ marginBottom: '12px' }}
                                className={`list-book cursor ${
                                  bookId === book._id ? 'book_active' : ''
                                }`}
                                onClick={() => handleBookSelect(book)}
                              >
                                {book.title}
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className='select_book_button'>
                          <button
                            type='button'
                            className='btn-black_create mt-0'
                            onClick={() => {
                              if (Storeuser?.status === 'waiting') setUserStatus(true);
                              else setSelectOption(true);
                            }}
                          >
                            Create Book
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <div
                  className='header_right_side_container'
                  style={{ width: '26%', justifyContent: 'space-evenly' }}
                >
                  <li className='cursor' style={{ margin: '0 5px' }}>
                    <Link
                      className='cursor text-decoration-none'
                      to='/dashboard'
                      onClick={() => {
                        localStorage.setItem('mode', 'create-mode');
                      }}
                    >
                      <img src={dashboard} alt='dashboard' />
                    </Link>
                  </li>
                  <li style={{ margin: '0px' }}>
                    <img src={bell} alt='bell' className='cursor' />
                  </li>
                  <li className='cursor' style={{ margin: '0 5px' }}>
                    <ProfileDropdown user={user} />
                  </li>
                </div>
                <li className='menu_icon'>
                  <a href='' className='menu_btn'>
                    <img src={menu} alt='numbered_list' />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <ModalPortal>
        <SelectOption selectOption={selectOption} setSelectOption={setSelectOption} />
      </ModalPortal>
    </>
  );
};

export default EditorToolbarFun;
